<div class="relative inline-block">
  @if (buttonData(); as btnData) {
    <div [class.hidden]="btnData.type !== 'icon'">
      <button mat-icon-button [cdkMenuTriggerFor]="menu">
        <mat-icon class="scale-[1.4]" [svgIcon]="btnData.content"></mat-icon>
      </button>
    </div>
    <div [class.hidden]="btnData.type !== 'text'">
      <button mat-button [cdkMenuTriggerFor]="menu">
        {{ btnData.content }}
        @if (isLoggedIn()) {
          <mat-icon
            svgIcon="chevron"
            class="scale-[.7] rotate-90"
            iconPositionEnd></mat-icon>
        }
      </button>
    </div>
  }
</div>

<ng-template #menu>
  <ul
    class="min-w-52 overflow-hidden z-[999] shadow-md rounded-xl"
    [ngClass]="dropContentCssClass()"
    cdkMenu>
    @if (isLoggedIn()) {
      <div class="flex relative items-center" [ngClass]="userPanelCssClass()">
        <mat-icon
          svgIcon="account-outline"
          class="min-h-12 min-w-12 rounded-full"></mat-icon>
        <div class="flex flex-col overflow-hidden whitespace-nowrap px-2 mr-2">
          <span>{{ userInfo()?.fullname }}</span>
          <span>{{ userInfo()?.username }}</span>
        </div>
      </div>
    }
    @for (action of actions(); track action.name) {
      <li (cdkMenuItemTriggered)="onAction(action)" cdkMenuItem>
        <a
          class="cursor-pointer no-underline block"
          [ngClass]="dropItemCssClass()"
          ><span>{{ action.title }}</span></a
        >
      </li>
    }
  </ul>
</ng-template>
